export const strikePriceListMapper = (data) => {
    var _a, _b, _c, _d;
    let result = {};
    if (data &&
        (data === null || data === void 0 ? void 0 : data.data) &&
        ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.stkPrcLst) &&
        ((_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.stkPrcLst) === null || _c === void 0 ? void 0 : _c.length) > 0) {
        result.strikePriceList = (_d = data === null || data === void 0 ? void 0 : data.data) === null || _d === void 0 ? void 0 : _d.stkPrcLst;
    }
    return result;
};
